import { UserRole } from './UserRole';

export interface UserSessionData {
  uid: string;
  email: string;
  role: UserRole;
  mustChangePassword: boolean;
  storeId?: string;
  merchantId?: string;
  displayName?: string;
}

export class UserSession {
  readonly uid: string;
  readonly email: string;
  readonly role: UserRole;
  readonly mustChangePassword: boolean;
  readonly storeId?: string;
  readonly merchantId?: string;
  readonly displayName?: string;

  constructor(data: UserSessionData) {
    this.uid = data.uid;
    this.email = data.email;
    this.role = data.role;
    this.mustChangePassword = data.mustChangePassword;
    this.storeId = data.storeId;
    this.merchantId = data.merchantId;
    this.displayName = data.displayName;
  }

  get isStaff(): boolean {
    return this.role.isStaff();
  }

  get isOwner(): boolean {
    return this.role.isOwner();
  }

  get isMaster(): boolean {
    // Assuming role 'master' exists or is represented in UserRole
    return (this.role as any).role === 'master';
  }
}
